import { APIScope, GroupInterface, Log, MemberPermission, RoleInterfaceMap } from "@swivl-mono/types";
import _ from "lodash";

import { CreateLogger } from "../Loggers/SwivlLoggers";
import { Internal_CheckPermissions } from "./CheckPermissions";

const log = CreateLogger(Log.AUTH, "helper");

export function Internal_AreAllLocationsAllowed(
  orgId: number,
  parentRoles: RoleInterfaceMap,
  roles: RoleInterfaceMap,
  memberPermissions: MemberPermission[],
) {
  return Internal_CheckPermissions(parentRoles, roles, memberPermissions, APIScope.LOCATION_VIEW, orgId);
}

export function Internal_FilterLocationsByPermissions(
  parentRoles: RoleInterfaceMap,
  roles: RoleInterfaceMap,
  memberPermissions: MemberPermission[],
  orgId: number,
  groups: GroupInterface[],
  scope: APIScope = APIScope.LOCATION_VIEW,
) {
  log("Internal_FilterLocationsByPermissions :", orgId, groups, scope);

  let output = _.cloneDeep(groups) as GroupInterface[];

  // First filter out all locations.
  for (let i = 0; i < output.length; i++) {
    output[i].locations = output[i].locations.filter((location) => {
      const filteringLocation = Internal_CheckPermissions(parentRoles, roles, memberPermissions, scope, orgId, output[i].id, location.id);
      log("filteringLocation :", location.name, filteringLocation);
      return filteringLocation;
    });
  }

  log("output step2");
  // Now remove groups that have no locations and I DONT have specific permissions for.
  output = output.filter((group) => {
    if (group.locations.length > 0) {
      return true;
    }
    const filteringGroup = Internal_CheckPermissions(parentRoles, roles, memberPermissions, scope, orgId, group.id);
    log("filteringGroup :", group.name, filteringGroup);
    return filteringGroup;
  });
  log("output :", output);

  return output;
}
